// extracted by mini-css-extract-plugin
export default {"title":"grid_title__VWUPk","numbers":"grid_numbers__7dMH1","completed":"grid_completed__sKD6O","skip":"grid_skip__TPbYm","current":"grid_current__wz-Ae"};